<a class="navbar-item-link a--border-off rounded-lg"
   [routerLinkActive]="'navbar-item-link--is-active'"
   [class.navbar-item-link--icon]="icon"
   [attr.title]="titleText"
   [routerLink]="link"
   role="menuitem"
   [ngClass]="customClass"
   tabindex="0"
   [class.a--white]="customClass?.indexOf('menu-item--brand') > -1">

    @if (icon) {
        <i [ngClass]="icon"></i>
    }
    <ng-content></ng-content>
</a>
